import React from 'react'
import PropTypes from 'prop-types'
import { Container } from 'reactstrap'
import CaliforniaNotice from 'shared/components/Footer/CaliforniaNotice'
import Branding from 'shared/branding'
import PatriotActDisclosure from './PatriotActDisclosure'
import { FooterLinks } from 'shared/components'
import { SHOWILPVALUE } from 'shared/components/Footer/ShowIlpConstValue'
import { APPLICATION_PATHS } from 'constants/paths'
import { useFlags } from 'launchdarkly-react-client-sdk'
import RefinanceDisclosure from './RefinanceDisclosure'

const CCBankFooter = ({
  copyrightYear,
  footerLinks,
  showIlp,
  showStandardArticles,
}) => {
  let counter = 1

  const ilpInfo = showIlp ? showIlp : SHOWILPVALUE
  const path = window.location.pathname
  const shouldNotApplytopMargin =
    path === APPLICATION_PATHS.LEAD_AGREEMENTS ||
    path.indexOf(APPLICATION_PATHS.NOT_APPROVED_LEAD_WELCOME) > -1
  const { enableDebitCardForFlow } = useFlags()
  const { brands: acceptedBrandsForFunding } = enableDebitCardForFlow
  return (
    <footer
      role="contentinfo"
      id="footer"
      className={shouldNotApplytopMargin ? '' : 'mt-5'}
    >
      <Container>
        <FooterLinks footerLinks={footerLinks} CCBFooter={true} />

        <h3
          data-test="text.online-disclosures-heading"
          id="online-disclosures-header"
        >
          Online Disclosures
        </h3>

        <PatriotActDisclosure />

        <div data-test="etc.online-disclosures" id="footer-content">
          <p>
            <strong>Customer Notice:</strong>
          </p>

          <p>
            {counter++}. The Xact® Loan is an installment loan made and funded
            by Quill Bank, a Utah chartered bank located in Provo, UT.
          </p>

          <p data-test="test.disclosures.standardArticles">
            {counter++}.{' '}
            {acceptedBrandsForFunding.includes(Branding.current.key)
              ? `Approval depends upon
            meeting legal, regulatory and underwriting requirements. All times
            and dates are based on Eastern Time (ET). Originated loans can be
            funded in as little as 30 minutes to a Visa debit card. Funding
            times may vary based on the consumer debit card bank. Funding to a
            MasterCard may be subject to restrictions. Funding by ACH may occur
            as soon as the same day. The lender may, at their discretion, verify
            application information by using national databases that may provide
            information from one or more national credit bureaus, and the lender
            may take that into consideration in the approval process.`
              : `Approval depends upon meeting legal, regulatory and underwriting requirements.
               All times and dates are based on Eastern Time (ET). If your loan is approved and originated by 8:00 p.m.
                ET on a business day, your funds will typically become available on the next business day.
                 The lender may, at their discretion, verify application information by using national databases
                  that may provide information from one or more national credit bureaus, and the lender may take that 
                  into consideration in the approval process. Products or services offered to customers may vary based on 
                  customer eligibility and applicable state or federal law. All available products subject to applicable
                   lender's terms and conditions. Actual loan amounts vary. Applicants must have an active checking account
                    open for at least 30 days.`}
          </p>

          {ilpInfo && (
            <p data-test="test.disclosures.ilp">
              {counter++}. Actual loan amount and terms will vary based on final
              evaluation of income and credit qualifications. Payment amounts
              vary by loan term and rate.  If approved, applicant may receive a
              loan ranging from $500 to $5,000.
            </p>
          )}

          <p>
            {counter++}. Payments must be made on time in order to enhance
            credit with lender.
          </p>

          <RefinanceDisclosure
            counter={counter}
            isRefinance={!showStandardArticles}
          />
          <p>
            Products or services offered to customers may vary based on customer
            eligibility and applicable state or federal law. All available
            products subject to applicable lender’s terms and conditions. Actual
            loan amounts vary.
          </p>

          <p>
            NEBRASKA RESIDENTS: A credit agreement must be in writing to be
            enforceable under Nebraska law. To protect you (borrower) and us
            (lender) from any misunderstandings or disappointments, any
            contract, promise, undertaking, or offer to forebear repayment of
            money or to make any other financial accommodation in connection
            with this loan of money or grant or extension of credit, or any
            amendment of, cancellation of, waiver of, or substitution for any or
            all of the terms or provisions of any instrument or document
            executed in connection with this loan of money or grant or extension
            of credit, must be in writing to be effective.
          </p>

          <p>
            RHODE ISLAND RESIDENTS: Credit reports - Notice to individual – I
            understand that a credit report may be requested in connection with
            my application for credit.
          </p>

          <p>
            CALIFORNIA RESIDENTS: If you are married, you may apply for an
            account separate from your spouse.
          </p>

          <p>
            ** Xact® doesn&apos;t charge you for using text messages (SMS) for
            two-factor authentication. However, your mobile provider&apos;s
            standard rates for sending and receiving messages may apply.
          </p>

          <p>
            &dagger; By providing your telephone number, including any mobile
            number, you consent that we may call you at these numbers for
            servicing and marketing telephone calls.
          </p>

          <p>
            The Company, individually or through its affiliates, is licensed as
            a Debt Collector by the California Department of Financial
            Protection and Innovation (DFPI), License Number 10435-99.
          </p>

          <CaliforniaNotice strong={false} brand={Branding.current.key} />

          <span data-test="text.copyright">
            &copy; {copyrightYear} Xact®. All rights reserved.
            <address>PO Box 36454, Cincinnati, OH 45236</address>
          </span>
        </div>
      </Container>
    </footer>
  )
}

CCBankFooter.displayName = 'Footer'
CCBankFooter.propTypes = {
  copyrightYear: PropTypes.number.isRequired,
  stateCode: PropTypes.string,
  showIlp: PropTypes.object,
  footerLinks: PropTypes.array,
  showStandardArticles: PropTypes.bool,
}

export default CCBankFooter
